// src/screens/Register.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import tealBack from '../Images/teal_dback.png';
import rypilLo from '../Images/rypilLo.png';
import businessIcon from '../Images/BusinessIcon.png';
import charityIcon from '../Images/CharityIcon.png';

const PEACH = '#EBA477';

function Register() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState(null);

  const handleNext = () => {
    if (selected === 'business') navigate('/business-registration');
    if (selected === 'nfp') navigate('/nfp/register');
  };

  return (
    <div
      style={{
        backgroundImage: `url(${tealBack})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '100vh',
        width: '100%',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        position: 'relative',
        color: 'white',
        fontFamily: 'Helvetica, Arial, sans-serif',
      }}
    >
      {/* Rounded border frame */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          borderRadius: 24,
          overflow: 'hidden',
          pointerEvents: 'none',
        }}
      />

      {/* Header */}
      <div
        style={{
          position: 'absolute',
          top: 64,
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 8,
          textAlign: 'center',
        }}
      >
        <h1 style={{ margin: 0, fontSize: 40, fontWeight: 500, letterSpacing: 2 }}>
          Choose Account Type
        </h1>
        <div style={{ fontSize: 20, opacity: 0.9 }}>Tell us what you're registering with rypil</div>
      </div>

      {/* Options grid */}
      <div
        style={{
          marginTop: 160,
          width: 'min(92vw, 1040px)',
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: 32,
        }}
      >
        {/* Business */}
        <button
          onClick={() => setSelected('business')}
          aria-pressed={selected === 'business'}
          style={{
            ...cardStyle,
            border:
              selected === 'business'
                ? `2px solid ${PEACH}`
                : '1px solid rgba(255,255,255,0.10)',
            transform: selected === 'business' ? 'translateY(-2px)' : 'translateY(0)',
          }}
        >
          <div style={cardTextStyle}>Business</div>
          <img
            src={businessIcon}
            alt="Business icon"
            style={{ height: 84, width: 'auto', opacity: 0.95 }}
          />
        </button>

        {/* NFP */}
        <button
          onClick={() => setSelected('nfp')}
          aria-pressed={selected === 'nfp'}
          style={{
            ...cardStyle,
            border:
              selected === 'nfp'
                ? `2px solid ${PEACH}`
                : '1px solid rgba(255,255,255,0.10)',
            transform: selected === 'nfp' ? 'translateY(-2px)' : 'translateY(0)',
          }}
        >
          <div style={cardTextStyle}>Nonprofit</div>
          <img
            src={charityIcon}
            alt="Charity icon"
            style={{ height: 84, width: 'auto', opacity: 0.95 }}
          />
        </button>
      </div>

      {/* Bottom-left rypil logo */}
      <img
        src={rypilLo}
        alt="rypil mark"
        style={{
          position: 'absolute',
          bottom: 28,
          left: 28,
          height: 56,
          opacity: 0.95,
        }}
      />

      {/* Bottom-right peach next button */}
        <button
          onClick={handleNext}
          aria-label="Next"
          disabled={!selected}
          title="Next"
          style={{
            position: 'absolute',
            bottom: 24,
            right: 32,
            minWidth: 120,
            height: 44,
            padding: '0 20px',
            borderRadius: 12,
            color: '#1d1d1d',
            background: selected ? PEACH : 'rgba(235,164,119,0.35)',
            border: 'none',
            fontSize: 16,
            fontWeight: 700,
            cursor: !selected ? 'not-allowed' : 'pointer',
            userSelect: 'none',
            opacity: !selected ? 0.5 : 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: selected ? '0 2px 10px rgba(0,0,0,0.25)' : 'none',
          }}
        >
          Next
        </button>


      {/* Mobile stacking */}
      <style>{`
        @media (max-width: 720px) {
          div[style*="gridTemplateColumns"] {
            grid-template-columns: 1fr !important;
          }
        }
        button:focus-visible {
          outline: 2px solid ${PEACH};
          outline-offset: 3px;
        }
      `}</style>
    </div>
  );
}

const cardStyle = {
  height: 260,                 // more box-like
  borderRadius: 18,
  background: 'rgba(255,255,255,0.10)',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)',
  color: 'white',
  cursor: 'pointer',
  boxShadow: '0 2px 10px rgba(0,0,0,0.25)',
  transition: 'border 0.2s ease, transform 0.15s ease, box-shadow 0.2s ease',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 16,
  padding: '18px 16px',
};

const cardTextStyle = {
  fontSize: 24,
  fontWeight: 600,
  letterSpacing: 0.5,
};

export default Register;
